// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"f6a8b4e6","898":"926607bc","967":"3ee6440a"}[chunkId] + ".chunk.css";
};